module.exports = __webpack_public_path__ + "media/images/regions/causal_graphs/latin_america_and_caribbean-c74bd080a7ace0d2276754d4859c90ed.svg";